(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();
